import { DASHBOARD_PILLAR_DEVIATION, DASHBOARD_PILLAR_TREND } from 'constants/dashboard';
import graphHigh from 'assets/img/mini-graph-high.svg';
import graphMid from 'assets/img/mini-graph-mid.svg';
import graphLow from 'assets/img/mini-graph-low.svg';
import arrowLrg from 'assets/img/icon-span-lrg.svg';
import arrowMed from 'assets/img/icon-span-med.svg';
import arrowSml from 'assets/img/icon-span-sml.svg';

export const generateTrendGraph = (trend) => {
  switch (trend) {
    case DASHBOARD_PILLAR_TREND.LOWER:
      return <img src={graphLow} alt="graphLow" />;
    case DASHBOARD_PILLAR_TREND.CONSTANT:
      return <img src={graphMid} alt="graphMid" />;
    case DASHBOARD_PILLAR_TREND.HIGHER:
      return <img src={graphHigh} alt="graphHigh" />;
    default:
      return null;
  }
};

export const generateScore = (deviation) => {
  if (deviation === DASHBOARD_PILLAR_DEVIATION.MEDIUM) {
    return <img src={arrowMed} alt="arrowMed" />;
  }

  if (deviation === DASHBOARD_PILLAR_DEVIATION.SMALL) {
    return <img src={arrowSml} alt="arrowSml" />;
  }

  if (deviation === DASHBOARD_PILLAR_DEVIATION.BIG) {
    return <img src={arrowLrg} alt="arrowLrg" />;
  }

  return '';
};
